(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-anchor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getScrollOffset() {
      var header = document.getElementById('header');
      var topHeader = document.querySelector('.top-header-wrapper');
      var offset = 0;
      if (header && header.classList.contains('stickyHeader') && window.getComputedStyle(header).position === 'fixed') {
        offset += header.offsetHeight || 0;
      }
      if (topHeader && window.getComputedStyle(topHeader).position === 'fixed') {
        offset += topHeader.offsetHeight || 0;
      }
      return offset;
    }

    function updateAnchorStickyTop() {
      var topVal = getScrollOffset() + 'px';
      document.querySelectorAll('.product-anchor--sticky').forEach(function (el) {
        el.style.setProperty('--anchor-sticky-top', topVal);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAnchorStickyTop);
    } else {
      updateAnchorStickyTop();
    }
    var scrollTicking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!scrollTicking) {
          requestAnimationFrame(function () {
            updateAnchorStickyTop();
            scrollTicking = false;
          });
          scrollTicking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', updateAnchorStickyTop);

    document.querySelectorAll('.product-anchor').forEach(function (sectionEl) {
      var links = sectionEl.querySelectorAll('.product-anchor__link[data-anchor]');
      var btnTop = sectionEl.querySelector('.product-anchor__btn-top');
      var sections = [];

      links.forEach(function (link) {
        var targetId = link.getAttribute('data-anchor');
        if (targetId) {
          var target = document.getElementById(targetId);
          if (target) sections.push({ link: link, target: target });
        }
      });

      function setActive(activeLink) {
        links.forEach(function (l) {
          l.classList.remove('product-anchor__link--active');
        });
        if (activeLink) activeLink.classList.add('product-anchor__link--active');
      }

      function onScroll() {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var viewportH = window.innerHeight;
        var active = null;
        for (var i = sections.length - 1; i >= 0; i--) {
          var rect = sections[i].target.getBoundingClientRect();
          if (rect.top <= viewportH * 0.3) {
            active = sections[i].link;
            break;
          }
        }
        if (!active && sections.length) active = sections[0].link;
        setActive(active);
      }

      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var targetId = link.getAttribute('data-anchor');
          if (!targetId) return;
          var target = document.getElementById(targetId);
          if (target) {
            e.preventDefault();
            var offset = getScrollOffset();
            var rect = target.getBoundingClientRect();
            var scrollTop = window.pageYOffset + rect.top - offset - 100;
            window.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
          }
        });
      });

      if (btnTop) {
        btnTop.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            requestAnimationFrame(function () {
              onScroll();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );
      onScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabArrows(sectionEl) {
      if (!sectionEl) return;
      var $section = $(sectionEl);
      var $prev = $section.find('.product-features-tabs__arrow--prev');
      var $next = $section.find('.product-features-tabs__arrow--next');
      var $tabLinks = $section.find('.product-features-tabs__tabs .tablink');
      if ($tabLinks.length === 0) return;
      $prev.off('click.product-features-tabs').on('click.product-features-tabs', function () {
        var $active = $section.find('.product-features-tabs__tabs li.active');
        var $target = $active.prev('li');
        if (!$target.length) $target = $section.find('.product-features-tabs__tabs li').last();
        var link = $target.find('.tablink')[0];
        if (link) link.click();
      });
      $next.off('click.product-features-tabs').on('click.product-features-tabs', function () {
        var $active = $section.find('.product-features-tabs__tabs li.active');
        var $target = $active.next('li');
        if (!$target.length) $target = $section.find('.product-features-tabs__tabs li').first();
        var link = $target.find('.tablink')[0];
        if (link) link.click();
      });
    }
    document.querySelectorAll('.product-features-tabs').forEach(function (el) {
      initTabArrows(el);
    });
    document.addEventListener('shopify:section:load', function (evt) {
      var sectionEl = document.getElementById('shopify-section-' + evt.detail.sectionId);
      if (sectionEl) {
        var inner = sectionEl.querySelector('.product-features-tabs');
        if (inner) initTabArrows(inner);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
